// extracted by css-extract-rspack-plugin
export default {"orderedList":"content-editor-plugin-ordered-list-OrderedList-orderedList-b8b81bb7"};